import Vue from "vue";
import Router from "vue-router";
import nlpAppEntities from "./components/nlp/sections/entities/index.vue";
import nlpAppEntitySingle from "./components/nlp/sections/entities/single.vue";
import nlpAppIntents from "./components/nlp/sections/intents/index.vue";
import nlpAppIntentsSingle from "./components/nlp/sections/intents/single.vue";
import nlpAppMain from "./components/nlp/sections/main";
import nlpAppUnknownWords from "./components/nlp/sections/unknownwords";
import nlpAppVersions from "./components/nlp/sections/versions";
import store from "./store";
import AI from "./views/AI.vue";
import Build from "./views/Build.vue";
import forget from "./views/forger-password";
import llm from "./views/llm";
import Login from "./views/Login";
import nlp from "./views/nlp";
import profile from "./views/profile";
import signup from "./views/sign-up";

import oldNlp from "./components/nlp/OldView";
import AppKeys from "./components/nlp/sections/AppKeys";
import analytics from "./views/analytics";
import Bots from "./views/Bots";
import publish from "./views/publish";
import settings from "./views/settings";
import users from "./views/users";

import botAnalytics from "./components/botAnalytics";
import ConfigureNotifications from "./components/settings/configureNotifications/ListAppNotifications";
import channelConfiguration from "./components/settings/general-setings/chnnaelConfiguration/channelCofiiguration";
import faqs from "./components/settings/widger-configuration/faqs/faqs";
import forms from "./components/settings/widger-configuration/forms/forms";
import introButtons from "./components/settings/widger-configuration/introButtons/introButtons";
import menus from "./components/settings/widger-configuration/menus/menus";
import page404 from "./views/404";
import activityLogs from "./views/activity-logs";
import customAnalytics from "./views/customAnalytics";
import filters from "./views/filters";
// import ChatHistory from "./views/ChatHistory";
import intentReportTool from "./components/nlp/reportTool/intentReportTool";
import badWords from "./components/settings/general-setings/badWords";
import facebookPages from "./components/settings/general-setings/facebookPages/facebookPages";
import googleReview from "./components/settings/general-setings/googleReviews/googleReview";
import SettingsVersions from "./components/settings/versions";

import chatHistoryNew from "./views/chat-histroy-new";

// campaign manager
import campaignOverview from "./components/campaign-manager/campaign-overview/campaignOverview";
import CampaignsCrud from "./components/campaign-manager/campaigns-crud/index.vue";
import CampaignsCrudSingle from "./components/campaign-manager/campaigns-crud/single.vue";
import CampaignsMain from "./components/campaign-manager/sections/main.vue";
import CampaignsOverview from "./components/campaign-manager/sections/overview.vue";
import TemplateMessageEditor from "./components/campaign-manager/template-message-editor/index.vue";
import TemplateMessagesCrud from "./components/campaign-manager/template-messages-crud/index.vue";
import WhatsappApps from "./components/campaign-manager/whatsapp-apps/index.vue";

import Configuration from "./components/llm/Configuration.vue";
import KnowledgeBase from "./components/llm/KnowledgeBase.vue";
import QuestionsAnswers from "./components/llm/QuestionsAnswers.vue";
import twitter from "./components/settings/general-setings/twitter/twitter";
Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: { layout: "auth" },
    },
    {
      path: "/sign-up",
      name: "signup",
      component: signup,
      meta: { layout: "auth" },
    },
    {
      path: "/forget-password",
      name: "forget",
      component: forget,
      meta: { layout: "no-sidebar" },
    },
    {
      path: "/profile",
      name: "profile",
      component: profile,
      meta: { layout: "default" },
    },
    {
      path: "/build",
      name: "build",
      component: Build,
      meta: { layout: "default", permission: ["groups", "blocks"] },
    },
    {
      path: "/ai",
      name: "ai",
      component: AI,
      meta: { layout: "default", permission: ["rules", "blocks"] },
    },
    {
      path: "/nlp-legacy",
      name: "oldnlp",
      component: oldNlp,
      meta: { layout: "default", permission: ["nlp"] },
    },
    {
      path: "/nlp",
      name: "nlp",
      component: nlp,
      meta: { layout: "default", permission: ["nlp"] },
    },
    {
      path: "/nlp/unknown-terms",
      component: nlpAppUnknownWords,
      name: "nlpUnknownWords",
      meta: { layout: "default", permission: ["nlp"], title: "Unknown Terms" },
    },
    {
      path: "/nlp/intents-report-tool",
      component: intentReportTool,
      name: "intentReportTool",
      meta: { layout: "default", permission: ["nlp"], title: "Unknown Terms" },
    },
    {
      path: "/nlp/app/:id",
      name: "nlpApp",
      component: nlpAppMain,
      meta: { layout: "default", permission: ["nlp"], title: "App" },
      children: [
        {
          path: "/nlp/app/:id/intents",
          component: nlpAppIntents,
          name: "nlpIntents",
          meta: { layout: "default", permission: ["nlp"], title: "Intents" },
        },
        {
          path: "/nlp/app/:id/intents/:intent",
          component: nlpAppIntentsSingle,
          name: "nlpAppIntentsSingle",
          meta: { layout: "default", permission: ["nlp"], title: "Intent" },
        },
        {
          path: "/nlp/app/:id/entities",
          component: nlpAppEntities,
          name: "nlpEntities",
          meta: { layout: "default", permission: ["nlp"], title: "Entities" },
        },
        {
          path: "/nlp/app/:id/entities/:entity",
          component: nlpAppEntitySingle,
          name: "nlpAppEntitySingle",
          meta: { layout: "default", permission: ["nlp"], title: "Entity" },
        },
        {
          path: "/nlp/app/:id/versions",
          component: nlpAppVersions,
          name: "nlpVersions",
          meta: { layout: "default", permission: ["nlp"], title: "Versions" },
        },
        {
          path: "/nlp/app/:id/keys",
          component: AppKeys,
          name: "nlpAppKeys",
          meta: {
            layout: "default",
            permission: ["nlp"],
            title: "Configure Keys",
          },
        },
      ],
    },
    {
      path: "/llm",
      name: "llm",
      component: llm,
      meta: { layout: "default", permission: ["llm"] },
      children: [
        {
          path: "/llm/configuration",
          component: Configuration,
          meta: { layout: "default", permission: ["llm"] },
        },
        {
          path: "/llm/knowledge-base",
          component: KnowledgeBase,
          meta: { layout: "default", permission: ["llm"] },
        },
        {
          path: "/llm/questions-answers",
          component: QuestionsAnswers,
          meta: { layout: "default", permission: ["llm"] },
        },
      ],
    },
    {
      path: "/settings",
      name: "settings",
      component: settings,
      meta: { layout: "default", permission: ["settings"] },
      children: [
        {
          path: "/settings/channel-configuration",
          component: channelConfiguration,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/google-reviews",
          component: googleReview,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/facebook-pages",
          component: facebookPages,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/twitter",
          component: twitter,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/bad-words",
          component: badWords,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/forms",
          component: forms,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/menus",
          component: menus,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/faqs",
          component: faqs,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/intro-buttons",
          component: introButtons,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/notifications",
          component: ConfigureNotifications,
          meta: { layout: "default", permission: ["settings"] },
        },
        {
          path: "/settings/versions",
          component: SettingsVersions,
          meta: { layout: "default", permission: ["settings"] },
        },
      ],
    },
    {
      path: "/campaigns/",
      name: "allCampaigns",
      component: CampaignsMain,
      meta: {
        layout: "default",
        permission: ["campaigns"],
        title: "Campaign Manager",
      },
      children: [
        {
          path: "/campaigns/all",
          component: CampaignsCrud,
          name: "CampaignsCrud",
          meta: {
            layout: "default",
            permission: ["campaigns"],
            title: "Campaings",
          },
        },
        {
          path: "/campaigns/overview",
          component: CampaignsOverview,
          name: "CampaignsOverview",
          meta: {
            layout: "default",
            permission: ["campaigns"],
            title: "Campaings",
          },
        },
        {
          path: "/campaigns/:id/editor",
          component: CampaignsCrudSingle,
          name: "CampaignsCrudSingle",
          meta: {
            layout: "default",
            permission: ["campaigns"],
            title: "Campaings",
          },
        },
        {
          path: "/campaigns/:id/overview",
          component: campaignOverview,
          name: "campaignOverview",
          meta: {
            layout: "default",
            permission: ["campaigns"],
            title: "Campaings",
          },
        },
        {
          path: "/campaigns/template-messages",
          component: TemplateMessagesCrud,
          name: "TemplateMessagesCrud",
          meta: {
            layout: "default",
            permission: ["campaigns"],
            title: "Template Messages",
          },
        },
        {
          path: "/campaigns/template-messages/:id/editor",
          component: TemplateMessageEditor,
          name: "TemplateMessageEditor",
          meta: {
            layout: "default",
            permission: ["campaigns"],
            title: "Template Message Editor",
          },
        },
        {
          path: "/campaigns/whatsapp-numbers",
          component: WhatsappApps,
          name: "WhatsappApps",
          meta: {
            layout: "default",
            permission: ["campaigns"],
            title: "Whatsapp Numbers",
          },
        },
      ],
    },
    {
      path: "/publish",
      name: "publish",
      component: publish,
      meta: { layout: "default", permission: ["settings"] },
    },
    {
      path: "/",
      name: "bots",
      component: Bots,
      meta: { layout: "default", permission: [] },
    },
    {
      path: "/users",
      name: "users",
      component: users,
      meta: { layout: "default", permission: ["users"] },
    },
    {
      path: "/activity-logs",
      name: "activity-logs",
      component: activityLogs,
      meta: { layout: "default", permission: ["activity_logs"] },
    },
    {
      path: "/insights",
      name: "analytics",
      component: botAnalytics,
      meta: { layout: "default", permission: ["analytics"] },
    },
    {
      path: "/insights-legacy",
      name: "botanalytics",
      component: analytics,
      meta: { layout: "default", permission: ["analytics"] },
    },
    {
      path: "/filters",
      name: "filters",
      component: filters,
      meta: { layout: "default", permission: [] },
    },

    {
      path: "/chat-history",
      name: "ChatHistory",
      component: chatHistoryNew,
      meta: { layout: "default", permission: ["blocks"] },
    },

    {
      path: "/404",
      name: "404",
      component: page404,
      meta: { layout: "default", permission: [] },
    },
    {
      path: "/custom-insights",
      name: "customInsights",
      component: customAnalytics,
      meta: { layout: "default", permission: [1] },
    },
  ],
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  if (
    !store.state.user.userToken &&
    !["/login", "/forget-password", "/sign-up"].includes(to.path)
  ) {
    return next("/login");
  }

  const userPermissions = store.state.user.userData.permissions;
  if (userPermissions && !userPermissions["*"]) {
    if (
      to.meta.permission &&
      to.meta.permission.length &&
      !to.meta.permission.some(
        (permission) =>
          userPermissions[permission] &&
          userPermissions[permission].includes("read")
      )
    ) {
      console.log("permission denied", to.meta.permission);
      return next("/404");
    }
  }

  if (
    store.state.user.userToken &&
    (to.path === "/login" ||
      (!store.state.bot.botId &&
        !["/", "/users", "/activity-logs", "/404", "/profile"].includes(
          to.path
        )))
  ) {
    return next("/");
  }

  // if (
  //   to.meta.permission &&
  //   !to.meta.permission.includes(store.state.user.roleId)
  // ) {
  //   if (store.state.user.roleId == 2) {
  //     return next("/chat-history");
  //   }
  //   return next("/insights");
  // }

  if (from.path === "/publish") {
    window.location.href = to.path;
  }

  store.dispatch("setCurrentRoute", to.path);
  localStorage.setItem("currentRoute", to.path);
  next();
});

export default router;
